import { render, staticRenderFns } from "./ChatForm.vue?vue&type=template&id=2e776472&scoped=true"
import script from "./ChatForm.vue?vue&type=script&lang=js"
export * from "./ChatForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e776472",
  null
  
)

export default component.exports